import React from 'react';
import { ArrowRightIcon, MessageCircleIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="bg-gradient-to-br from-slate-50 to-primary-50 pt-16 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-115">
      <div className="max-w-7xl mx-auto" data-id="element-116">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-117">
          {/* Content */}
          <div data-id="element-118">
            <div className="inline-flex items-center gap-2 bg-primary-100 text-primary-700 px-4 py-2 rounded-full text-sm font-semibold mb-6" data-id="element-119">
              <span className="w-2 h-2 bg-primary-600 rounded-full animate-pulse" data-id="element-120"></span>
              Aprobación en menos de 48 horas
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight mb-6" data-id="element-121">
              Arrendamiento Puro para Empresas y Profesionistas
            </h1>

            <p className="text-xl text-slate-600 mb-8 leading-relaxed" data-id="element-122">
              Reduce impuestos, conserva liquidez y estrena activos sin
              descapitalizarte.
              <span className="font-semibold text-slate-900" data-id="element-123">
                {' '}
                100% deducible
              </span>{' '}
              según Ley ISR.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-124">
              <Button size="lg" data-id="element-125">
                Cotiza en 30 segundos
                <ArrowRightIcon className="w-5 h-5" data-id="element-126" />
              </Button>
              <Button variant="outline" size="lg" data-id="element-127">
                <MessageCircleIcon className="w-5 h-5" data-id="element-128" />
                Habla con un asesor
              </Button>
            </div>

            <div className="flex items-center gap-6 text-sm text-slate-600" data-id="element-129">
              <div className="flex items-center gap-2" data-id="element-130">
                <svg className="w-5 h-5 text-success" fill="currentColor" viewBox="0 0 20 20" data-id="element-131">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-132" />
                </svg>
                Sin enganche
              </div>
              <div className="flex items-center gap-2" data-id="element-133">
                <svg className="w-5 h-5 text-success" fill="currentColor" viewBox="0 0 20 20" data-id="element-134">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-135" />
                </svg>
                Sin penalización
              </div>
              <div className="flex items-center gap-2" data-id="element-136">
                <svg className="w-5 h-5 text-success" fill="currentColor" viewBox="0 0 20 20" data-id="element-137">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-138" />
                </svg>
                +20 años de experiencia
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="relative" data-id="element-139">
            <div className="bg-white rounded-2xl shadow-2xl p-8 border border-slate-200" data-id="element-140">
              <div className="aspect-video bg-gradient-to-br from-primary-100 to-primary-200 rounded-lg flex items-center justify-center" data-id="element-141">
                <div className="text-center" data-id="element-142">
                  <div className="w-20 h-20 bg-primary-600 rounded-full mx-auto mb-4 flex items-center justify-center" data-id="element-143">
                    <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-144">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-145" />
                    </svg>
                  </div>
                  <p className="text-slate-600 font-medium" data-id="element-146">
                    Vehículos, maquinaria, equipo
                  </p>
                  <p className="text-2xl font-bold text-primary-700 mt-2" data-id="element-147">
                    100% Deducible
                  </p>
                </div>
              </div>
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-4 -right-4 bg-white rounded-xl shadow-xl p-4 border border-slate-200" data-id="element-148">
              <div className="flex items-center gap-3" data-id="element-149">
                <div className="w-12 h-12 bg-success/10 rounded-full flex items-center justify-center" data-id="element-150">
                  <svg className="w-6 h-6 text-success" fill="currentColor" viewBox="0 0 20 20" data-id="element-151">
                    <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" data-id="element-152" />
                  </svg>
                </div>
                <div data-id="element-153">
                  <p className="text-xs text-slate-600" data-id="element-154">Ahorro fiscal</p>
                  <p className="text-lg font-bold text-slate-900" data-id="element-155">Hasta 30%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}